import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import VirtualTable from '../../../components/custom/VirtualTable';
import { ChangeEvent, ChoiceEmployee, MessageGroupData } from '../../../globals/interfaces';
import { FormGroup } from 'reactstrap';
import { Input } from 'reactstrap';
import { Action } from 'history';
import { CreateGroup, DeleteGroup, UpdateGroup } from '.';
import { notify } from '../../../utils';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    isUpdatingGroup: boolean;
    selectedGroup: MessageGroupData | undefined;
    createGroup: CreateGroup;
    updateGroup: UpdateGroup;
    deleteGroup: DeleteGroup;
}

export default function ModalManageGroups({
    modal,
    setModal,
    isUpdatingGroup,
    selectedGroup,
    createGroup,
    updateGroup,
    deleteGroup
}: Props) {

    const [name, setName] = useState('');
    const update = Boolean(isUpdatingGroup && selectedGroup !== undefined);

    useEffect(() => {
        setName(update ? selectedGroup!.name : '');
    }, [modal]);

    const toggle = () => setModal(!modal);
    const handleCreateUpdate = async () => {
        if (update) {
            await updateGroup(name, selectedGroup!.id);
        } else {
            await createGroup(name);
        }
        setModal(false);
        notify('Success');
    }

    const handleDelete = async (id: number) => {
        await deleteGroup(id);
        setModal(false);
        notify('Deleted');
    }

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>{update ? 'Update' : 'Create'} Group</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Name</Label>
                    <Input value={name} onChange={(e: ChangeEvent) => setName(e.target.value)} />
                </FormGroup>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer update={update}>
                        {
                            (isUpdatingGroup && selectedGroup) && (
                                <ActionIcon type={'delete'} onClick={() => handleDelete(selectedGroup.id)} />
                            )
                        }
                        <ActionIcon type={'save'} onClick={handleCreateUpdate} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;